import React from 'react'

const MonerisPayPageLinks = ({
  labels,
  activeModifyBooking,
  onConfirmClick,
  onCancelClick
}) => {
  return (
    <div className="payment-form-section">
      <p className="payment-instructions">{labels.confirmPaymentModalTitle}</p>
      <p className="payment-instructions">{labels.confirmPaymentModalCopy}</p>

      {activeModifyBooking && (
        <p className="payment-instructions">
          {labels.confirmPaymentModalAttention}
        </p>
      )}

      <button className="btn btn-primary" onClick={onConfirmClick}>
        {labels.confirmPaymentContinueButtonText}
      </button>
      <button className="btn btn-secondary" onClick={onCancelClick}>
        {labels.confirmPaymentCancelButtonText}
      </button>
    </div>
  )
}

export default MonerisPayPageLinks
